import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/stores/authStore";
import { listLanguages } from "@/services/api/i18n";

/** The locale registry (active languages with direction metadata). */
export function useLanguages() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["languages"],
    queryFn: () => listLanguages(),
    enabled: Boolean(user),
    staleTime: 60_000,
  });
}
